import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import DownloadApp from '../views/DownloadApp'
import CompanyIntroductions from "../views/CompanyIntroductions";
import News from "../views/News";
import NewsDetail from "../views/NewsDetail";
import Organization from "../views/Organization";
import CompanyCulture from "../views/CompanyCulture";
import CompanySystem from "../views/CompanySystem";
import ContactUs from "../views/ContactUs";
import AgencyBusiness from "../views/AgencyBusiness";
import PersonalBusiness from "../views/PersonalBusiness";
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta:{title: '首页'}
    },
    {
        path: '/download_app',
        name: 'DownloadApp',
        component: DownloadApp,
        meta: {title: '下载app'}
    },
    {
        path: '/company_introductions',
        name: 'CompanyIntroductions',
        component: CompanyIntroductions,
        meta:{title: '公司简介'}
    },
    {
        path: '/news',
        name: 'News',
        component: News,
        meta:{title: '新闻'}
    },
    {
        path: '/news_detail/:id',
        name: 'NewsDetail',
        component: NewsDetail,
        meta:{title: '新闻详情'}
    },
    {
        path: '/organization',
        name: 'Organization',
        component: Organization,
        meta:{title: '组织架构'}
    },
    {
        path: '/company_culture',
        name: 'CompanyCulture',
        component: CompanyCulture,
        meta:{title: '公司文化'}
    },
    {
        path: '/company_system',
        name: 'CompanySystem',
        component: CompanySystem,
        meta:{title: '公司制度'}
    },
    {
        path: '/contact_us',
        name: 'ContactUs',
        component: ContactUs,
        meta:{title: '联系我们'}
    },
    {
        path: '/agency_business',
        name: 'AgencyBusiness',
        component: AgencyBusiness,
        meta: {title: '业务公告详情页面,机构业务页面'}
    },
    {
        path: '/personal_business',
        name: 'PersonalBusiness',
        component: PersonalBusiness,
        meta: {title: '个人业务'}
    }
   ]
})
